import { CheckboxGroup } from './CheckboxGroup'
import { CheckboxItem } from './CheckboxItem'
import { CheckboxParent } from './CheckboxParent'

CheckboxGroup.Item = CheckboxItem
CheckboxGroup.Parent = CheckboxParent

export { CHECKBOX_SIZE } from './CheckboxItem'
export { CheckboxGroup }
